import { Typography, TypographyProps } from "../../components/Typography";

export const ProductSectionTitle = (props: TypographyProps) => {
    return <Typography variant="headline" size="small" {...props} data-testid="product-section-title" />;
};
